import { ReactRefI } from "type/common/ref.type";
import CharacterRelateGroupEdit from "../CharacterRelateGroupEdit";
import { CHARACTER_RELATE_CONTAIN_TAGS } from "./CharacterRelateContainEdit.const";

type CharacterRelateContainEditProps = {
  resultRef: ReactRefI<string[]>;
  onUpdate?: Function;
  resultMax?: number;
  label?: string;
};

const CharacterRelateContainEdit = ({
  resultRef,
  onUpdate,
  resultMax,
  label,
}: CharacterRelateContainEditProps) => {
  return (
    <CharacterRelateGroupEdit
      label={label ?? "relate contain"}
      initialValue={resultRef.current ?? []}
      resultRef={resultRef}
      tags={CHARACTER_RELATE_CONTAIN_TAGS}
      onUpdate={onUpdate}
      resultMax={resultMax}
    />
  );
};

export default CharacterRelateContainEdit;
